import gql from 'graphql-tag'

export const GET_CLIENT_LEVEL_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getClientLevelPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        title
				level
				minDirectReferrals
				minNetworkPurchases
				minPersonalPurchases
				reachedBonus
      }
    }
  }
`;

export const GET_CLIENT_LEVEL_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getClientLevel (
      data: {
        id: $id
      }
    ) {
      id
			title
			level
			minDirectReferrals
			minNetworkPurchases
			minPersonalPurchases
			reachedBonus
    }
  }
`;
